import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function Groups3Icon(props: IconProps) {
    return <Icon {...props} iconKey={"groups_3"}/>
}
